function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.5013 55.9993H24.5013C22.868 55.9993 21.0013 54.5993 21.0013 51.7993V46.8993C21.0013 44.566 19.8346 42.466 17.968 40.8327C13.768 37.566 11.668 32.8993 11.668 27.766C11.9013 18.8993 19.1346 11.8993 27.768 11.666C32.2013 11.666 36.4013 13.2993 39.4346 16.3327C42.468 19.366 44.3346 23.566 44.3346 27.9993C44.3346 32.8993 42.2346 37.566 38.268 40.5993C36.168 42.2327 35.0013 44.7993 35.0013 47.1327V52.4993C35.0013 54.366 33.368 55.9993 31.5013 55.9993ZM28.0013 13.9993C20.5346 13.9993 14.2346 20.2993 14.0013 27.766C14.0013 32.1993 15.868 36.3993 19.368 38.966C21.9346 41.066 23.3346 43.866 23.3346 46.8993V51.7993C23.3346 52.266 23.3346 53.666 24.5013 53.666H31.5013C32.2013 53.666 32.668 53.1993 32.668 52.4993V47.1327C32.668 44.0993 34.3013 40.8327 36.868 38.7327C40.1346 36.166 42.0013 32.1993 42.0013 27.9993C42.0013 24.266 40.6013 20.766 37.8013 17.966C35.2346 15.3993 31.7346 13.9993 28.0013 13.9993Z",
  fill: "#E8388A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8333 48.9993H22.1667C21.4667 48.9993 21 48.5327 21 47.8327C21 47.1327 21.4667 46.666 22.1667 46.666H33.8333C34.5333 46.666 35 47.1327 35 47.8327C35 48.5327 34.5333 48.9993 33.8333 48.9993Z",
  fill: "#E8388A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9987 7C27.2987 7 26.832 6.53333 26.832 5.83333V1.16667C26.832 0.466667 27.2987 0 27.9987 0C28.6987 0 29.1654 0.466667 29.1654 1.16667V5.83333C29.1654 6.53333 28.6987 7 27.9987 7Z",
  fill: "#E8388A"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M43.6349 13.5341C43.4016 13.5341 42.9349 13.5341 42.7016 13.3008C42.2349 12.8341 42.2349 12.1341 42.7016 11.6674L45.9682 8.40078C46.4349 7.93411 47.1349 7.93411 47.6016 8.40078C48.0682 8.86745 48.0682 9.56745 47.6016 10.0341L44.3349 13.3008C44.3349 13.3008 43.8682 13.5341 43.6349 13.5341Z",
  fill: "#E8388A"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M54.8333 29.1673H50.1667C49.4667 29.1673 49 28.7006 49 28.0006C49 27.3006 49.4667 26.834 50.1667 26.834H54.8333C55.5333 26.834 56 27.3006 56 28.0006C56 28.7006 55.5333 29.1673 54.8333 29.1673Z",
  fill: "#E8388A"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M46.9016 48.0673C46.6682 48.0673 46.2016 48.0673 45.9682 47.834L42.7016 44.5673C42.2349 44.1007 42.2349 43.4007 42.7016 42.934C43.1682 42.4673 43.8682 42.4673 44.3349 42.934L47.6016 46.2006C48.0682 46.6673 48.0682 47.3673 47.6016 47.834C47.6016 48.0673 47.3682 48.0673 46.9016 48.0673Z",
  fill: "#E8388A"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M9.09974 48.0673C8.86641 48.0673 8.39974 48.0673 8.16641 47.834C7.69974 47.3673 7.69974 46.6673 8.16641 46.2006L11.4331 42.934C11.8997 42.4673 12.5997 42.4673 13.0664 42.934C13.5331 43.4007 13.5331 44.1007 13.0664 44.5673L9.79974 47.834C9.56641 48.0673 9.33307 48.0673 9.09974 48.0673Z",
  fill: "#E8388A"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M5.83333 29.1673H1.16667C0.466667 29.1673 0 28.7006 0 28.0006C0 27.3006 0.466667 26.834 1.16667 26.834H5.83333C6.53333 26.834 7 27.3006 7 28.0006C7 28.7006 6.53333 29.1673 5.83333 29.1673Z",
  fill: "#E8388A"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3664 13.5331C12.1331 13.5331 11.6664 13.5331 11.4331 13.2997L8.16641 9.79974C7.69974 9.33307 7.69974 8.63307 8.16641 8.16641C8.63307 7.69974 9.33307 7.69974 9.79974 8.16641L13.0664 11.4331C13.5331 11.8997 13.5331 12.5997 13.0664 13.0664C12.8331 13.2997 12.5997 13.5331 12.3664 13.5331Z",
  fill: "#E8388A"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M37.332 29.1667C36.632 29.1667 36.1654 28.7 36.1654 28C36.1654 23.5667 32.432 19.8333 27.9987 19.8333C27.2987 19.8333 26.832 19.3667 26.832 18.6667C26.832 17.9667 27.2987 17.5 27.9987 17.5C33.832 17.5 38.4987 22.1667 38.4987 28C38.4987 28.7 38.032 29.1667 37.332 29.1667Z",
  fill: "#E8388A"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 56,
  fill: "white"
})));

var SvgConnect4 = function SvgConnect4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConnect4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/connect_4.7593ab1c.svg";
export { ForwardRef as ReactComponent };